/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { IconButton,
  makeStyles,
  Theme,
  Avatar,
  Grid,
  CircularProgress,
  useMediaQuery,
  useTheme,
  GridSize } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useUser } from '../contexts/UserContext';
import { UserNetwork } from '../types/types';
import Button from './Button';
import { StyledText } from './StyledText';
import LinkedinIcon from './LinkedinIcon';
import StatusChip from './StatusChip';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '15px 0',
    backgroundColor: 'white',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    minHeight: 75,
    padding: '5px 20px'
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(0, 2)
  },
  leftSideGrid: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '1 1 80%'
  },
  rightSideGrid: {
    flex: '0 1 20%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: theme.spacing(1)
  },
  summary: {
    margin: 0
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  column: {
    flexBasis: '33.33%'
  },
  detail: {
    display: 'flex',
    flexDirection: 'column'
  },

  contactName: {
    display: 'inline-flex',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    wordBreak: 'break-all',
    alignItems: 'center',
    marginLeft: '20px',
    '& div:nth-child(2)': {
      marginLeft: 20
    },
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },
  companyName: {
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    wordBreak: 'break-all'
  },
  email: {
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    wordBreak: 'break-all'
  },
  statusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: 'auto'
  }
}));

interface NetworkListItemProps {
  userNetwork: UserNetwork
}

const NetworkListItem: React.FC<NetworkListItemProps> = (props) => {
  const { userNetwork } = props;
  const styles = useStyles();
  const history = useHistory();
  const { userInfo } = useUser();
  const { investor } = userNetwork;

  const handleViewProfile = () => {
    history.push(`/investor/${investor.id}`, { from: window.location.pathname });
  };

  const handleLinkedin = () => {
    window.open(investor.linkedinProfile, '_blank'); // TODO: add linkedin
  };

  const theme = useTheme();
  const matchesMedScreen = useMediaQuery(theme.breakpoints.up('lg'));

  if (!userInfo || !investor) return <CircularProgress />;

  const showLinkedIn = (matchesMedScreen && !!investor.linkedinProfile);

  return (
    <div className={styles.root}>
      <div className={styles.gridContainer}>
        <Grid container spacing={1} xs='auto' alignContent='center' alignItems='center' className={styles.leftSideGrid} wrap='nowrap'>
          <Grid item xs={4}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} onClick={handleViewProfile}>
              <Avatar src={investor.profileImage} />
              <StyledText className={styles.contactName}>{investor.contactName}</StyledText>
            </div>
          </Grid>
          <Grid item xs={4} className={styles.companyName}>
            <StyledText align='left'>{investor.companyName}</StyledText>
          </Grid>
          <Grid item xs={4} className={styles.email}>
            <StyledText align='left'>{investor.email}</StyledText>
          </Grid>
          <Grid item xs={1} justify='center'>
            { showLinkedIn && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <IconButton onClick={handleLinkedin}>
                <LinkedinIcon />
              </IconButton>
            </div>
            )}
          </Grid>
          <Grid item xs={2} className={styles.statusChip}>
            {!userNetwork.investor.isPublished && (
              <StatusChip status='Incomplete' />
            )}
          </Grid>
          <Grid item xs={2} justify='flex-end'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <Button variant='text' onClick={handleViewProfile}>View profile</Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default NetworkListItem;
